module.exports = __webpack_public_path__ + "img/196.e7767366.jpg";